import { render, staticRenderFns } from "./PhotoAlbum.vue?vue&type=template&id=2ed4d826&"
import script from "./PhotoAlbum.vue?vue&type=script&lang=js&"
export * from "./PhotoAlbum.vue?vue&type=script&lang=js&"
import style0 from "./PhotoAlbum.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports